import Vue from 'vue';

// 封装Toast显示函数
function showToast(type, message) {
  if (Vue.prototype.$toast) {
    if (type === "success") {
      Vue.prototype.$toast.success(message);
    } else {
      Vue.prototype.$toast.fail(message);
    }
  }
}
// 定义全局复制方法
Vue.prototype.copyText = function (text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    if (successful) {
      showToast("success", "复制成功");
    } else {
      throw new Error("execCommand failed");
    }
  } catch (err) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => {
          showToast("success", "复制成功");
        })
        .catch(() => {
          showToast("fail", "复制失败");
        });
    } else {
      showToast("fail", "复制失败");
    }
  } finally {
    document.body.removeChild(textArea);
  }
};